var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"fullscreen-iframe",class:{'loading-content': _vm.loading},attrs:{"id":"modal-fullscreen","src":_vm.url,"frameborder":"0","allowfullscreen":""},on:{"load":_vm.onLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }